import React from "react";
import { MacroCalculator } from "../components/widgetManager/components/MacroCalculator";
import { RecipeWidgetManager } from "../components/widgetManager/components/RecipeWidgetManager";
import { StoreWidgetManager } from "../components/widgetManager/components/StoreWidgetManager";
import { LinkWidgetManager } from "../components/widgetManager/components/LinkWidgetManager";
import { FileDocumentWidgetManager } from "../components/widgetManager/components/FileDocumentWidgetManager";
import { VideoWidgetManager } from "../components/widgetManager/components/VideoWidgetManager";
import submit from "submit-form";
import { MealPlanLibraryWidgetManager } from "../components/widgetManager/components/MealPlanLibraryWidgetManager";
import { DailyAccountabilityWidgetManager } from "../components/widgetManager/components/DailyAccountabilityWidgetManager";

const WidgetManager = ({ locals, type }) => {
  const goBack = () =>
    submit(`/actions/refresh/?`, {
      method: "GET",
      body: { widget: "", section: "main", type: "" },
    });
  const managerTypes = {
    "macro-calculator": <MacroCalculator locals={locals} goBack={goBack} />,
    recipe: <RecipeWidgetManager locals={locals} goBack={goBack} />,
    store: <StoreWidgetManager locals={locals} goBack={goBack} />,
    links: <LinkWidgetManager locals={locals} goBack={goBack} />,
    "file-documents": (
      <FileDocumentWidgetManager locals={locals} goBack={goBack} />
    ),
    "video-playlist": <VideoWidgetManager locals={locals} goBack={goBack} />,
    "meal-plan-library": (
      <MealPlanLibraryWidgetManager locals={locals} goBack={goBack} />
    ),
    "daily-accountability-template": (
      <DailyAccountabilityWidgetManager locals={locals} goBack={goBack} />
    ),
  };
  return managerTypes[type];
};

export default WidgetManager;
